module.exports = __webpack_public_path__ + "static/img/3.4669da6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/3.png
// module id = bwRH
// module chunks = 0